<template>
  <div class=" d-flex flex-column fill-height main-cont">
    <!-- messages:{{ messages }} -->
    <!-- instructions:{{ instructions }} -->
    <!-- <v-btn @click="requestCall">Request Call</v-btn> -->
    <!-- STREAMING:{{ streaming }} -->

    <!-- <div v-if="letterTest" v-html="letterTest"></div> -->
    <v-alert type="info" v-if="simulatorMessage">
      {{ simulatorMessage }}
    </v-alert>
    <v-alert type="success" v-if="successMessage">
      {{ successMessage }}
    </v-alert>

    <v-dialog v-model="dialog" v-if="schema">
      <v-card>
        <v-card-text>
          <v-form-component
            ref="formComponent"
            :key="formKey"
            :model="instructionModel"
            :vModel="instructionModel"
            :schema="schema"
          ></v-form-component
        ></v-card-text>
        <v-select
          class="ma-2"
          v-model="assistantModel.disabled_functions"
          :items="availableFunctions"
          label="Disabled functions"
          multiple
          chips
          clearable
          dense
        />
        <v-card-actions class=" justify-center">
          <!-- <v-spacer></v-spacer> -->

          <v-switch label="Update Production" v-model="updateServer"></v-switch>
          <v-btn color="warning" small @click="resetInstructions()">Reset</v-btn>
          <v-btn color="primary" small @click="saveInstructions()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-if="editMode">
      <v-row>
        <v-col><v-btn v-if="editMode && schema" @click="dialog = 1">Edit Instructions</v-btn></v-col>
        <v-col><v-btn v-if="editMode && schema" @click="clearCache">Clear Cache</v-btn></v-col>
        <v-col v-if="assistantModel"
          ><v-switch
            @change="saveInstructions()"
            label="First Message Off"
            v-model="assistantModel.first_message_off"
          ></v-switch
        ></v-col>
        <v-col v-if="assistantModel"
          ><v-switch
            @change="saveInstructions()"
            label="Simulation Mode"
            v-model="assistantModel.simulation_mode"
          ></v-switch
        ></v-col>

        <v-col v-if="assistantModel"
          ><v-switch @change="saveInstructions()" label="Auto Simulate" v-model="assistantModel.autoSimulate"></v-switch
        ></v-col>

        <v-col>
          <v-text-field
            v-if="editMode && assistantId"
            class="ma-2 admin-text-field"
            v-model="adminMessage"
            placeholder="DEV OVERRIDE (system-level). Interrupt, audit, or adjust behavior…"
            ref="adminText"
            dense
            outlined
            color="deep-orange"
            @keydown.enter="sendAdminOverride"
        /></v-col>
      </v-row>

      <v-expansion-panels v-if="editMode" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Instructions
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <div class="check-instructions">
              {{ instructions }}
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <h3 v-if="chatReady && assistantModel && assistantModel.display_assistant_name" class="ma-2">
      {{ assistantName }}
    </h3>

    <div v-if="chatReady && assistantList && !assistantId && !hideAssistantsList" class="assistant-list">
      <v-list flat>
        <v-list-item
          @click="getMessages(c)"
          text
          v-for="c in chats.filter(a => {
            return a.display_assistant_name;
          })"
          :key="c._id"
        >
          <v-icon>mdi-wechat</v-icon>
          {{ c ? c.name : "" }}
        </v-list-item>
      </v-list>
    </div>
    <!-- <v-list class="thread-list" v-if="!hideThreads && chatReady && assistantModel && assistantModel.show_all_threads">
      <v-btn class="ml-4 mb-2" color="info" v-if="assistant_id && !hideNewChat" text @click="selectThread('')">
        <v-icon class="ma-2">mdi-chat</v-icon> New Chat</v-btn
      >

      <v-list-item v-for="(t, i) in threads" :key="i">
        <v-btn color="info" text @click="selectThread(t.thread_id)">
          <v-icon class="ma-2">mdi-chat-question-outline</v-icon>

        </v-btn>
        <v-btn color="error" class="ma-2" @click="deleteThread(t)" icon><v-icon>mdi-close</v-icon></v-btn>
      </v-list-item>
    </v-list> -->
    <!-- <v-btn text color="primary" @click="startVoiceChat" v-if="!voiceActive">
      🎤 Start Voice Chat
    </v-btn>

    <v-btn text color="error" @click="stopVoiceChat" v-if="voiceActive">
      🛑 Stop Voice Chat
    </v-btn> -->
    <!-- <v-btn text color="primary" @click="startVoice">🎤 Voice Start</v-btn>
    <v-btn text color="error" @click="stopVoice">🛑 Voice Stop</v-btn> -->

    <hr />
    <!--      -->
    <div v-if="initialzing" class="assistant-loading">
      <v-progress-circular indeterminate size="20" width="2" color="primary" class="mr-2" />
      <span>Assistant is preparing your request...</span>
    </div>
    <v-list
      class="pa-2"
      :style="'height:' + messageListHeight + 'px; min-width: 300px'"
      :key="msgKey"
      id="message-list"
    >
      <v-list-item class="ma-2" v-if="!thread_id && !hasInitialMessage">
        <v-icon color="green" large> mdi-assistant > </v-icon>{{ initialMessage }}</v-list-item
      >
      <v-list-item
        :class="message.class + ' d-flex align-start ma-2'"
        :style="'background-color:' + message.color"
        v-for="(message, index) in messages.filter(m => !hideThreads)"
        :key="index"
      >
        <v-icon :color="message.role == 'assistant' ? 'green' : 'blue'" large class="ma-2">
          {{ message.role == "assistant" ? "mdi-assistant" : "mdi-account" }}
        </v-icon>

        <!-- MESSAGE + BUTTONS COLUMN -->
        <v-list-item-content class="ma-2 d-flex flex-column">
          <div v-if="message.content" class="message" v-html="convertMarkdownLinksToHTML(message.content).html" />
        </v-list-item-content>
      </v-list-item>
      <v-div v-if="editMode && assistantModel && !assistantModel.autoSimulate && assistantModel.simulation_mode">
        <!-- {{ simulatorMessage }} -->
        <v-btn @click="callSimulator">Simulate Anser</v-btn>
      </v-div>

      <v-row style="overflow: hidden" v-if="loading && !streaming">
        <v-col cols="12" md="auto">
          <v-img style="height: 40px; width: 40px" :src="actionImage" />
        </v-col>
        <v-col cols="12" md>
          <v-card flat style="overflow: hidden">
            <v-card-text>
              <p>{{ actionMessage }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <div v-if="loading && streaming" class="chat-bubble">
        <div class="typing">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      <span v-if="runningFunction && !streaming">checking data...</span>
      <v-list-item v-if="streaming && loading">
        <div class="streaming" v-html="convertMarkdownLinksToHTML(streaming).html"></div>
      </v-list-item>
    </v-list>
    <v-container fluid>
      <v-alert class="ma-4" timeout="3000" dismissible v-if="errorMessage != '' && errorMessage" type="error">
        {{ errorMessage }}
      </v-alert>
      <v-row v-if="uploadImages">
        <v-col>
          <div>
            <v-upload
              class="image-block"
              objectName="aichat"
              :externalDropTarget="dropTarget"
              :uploadThumbnailHeight="128"
              :key="uploadKey"
              :formModel="formModel"
              :uploadOnly="true"
              :portal_id="portal_id"
              :customSuccessMessage="customSuccessMessage"
              @file-uploading="uploading = true"
            ></v-upload>
          </div>
        </v-col>
      </v-row>

      <v-row class="user-input-row" align="center" justify="center">
        <!-- CAMERA BUTTONS -->
        <!-- <v-col v-if="cameraButtons" cols="12" class="mb-2 d-flex justify-center">
          <v-row dense justify="center">
            <v-col v-for="room in cameraButtons" :key="room" cols="12" class="d-flex justify-center">
              <v-btn
                large
                color="primary"
                prepend-icon="mdi-camera"
                class="camera-room-button mx-auto"
                style="max-width: 420px;"
                @click="selectCameraRoom(room)"
              >
                {{ room }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col> -->

        <!-- NORMAL CHOICES -->
        <canvas style="display:none" ref="canvas"></canvas>
        <v-row class="d-flex justify-center" v-if="frameList.length" dense>
          <v-col v-for="(img, index) in frameList" :key="index" cols="auto">
            <div class="img-container">
              <v-img :src="img" contain max-height="240" max-width="240" />

              <v-btn icon small class="img-close-btn" color="error" @click="removeItem(index)">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-col>

          <v-col class="d-flex justify-center" cols="12">
            <v-btn color="info" @click="triggerPhotoInput()" v-if="photoTaken && maxPhotos - frameList.length > 0"
              ><v-icon>mdi-camera</v-icon> Take another photo ({{ maxPhotos - frameList.length }} left)
            </v-btn>
            <br />
          </v-col>
          <v-col class="d-flex justify-center" cols="12">
            <v-btn color="success" v-if="frameList.length" @click="askAssistant()">
              <v-icon>mdi-check</v-icon>Submit {{ frameList.length }} photos
            </v-btn>
          </v-col>
        </v-row>

        <v-col v-if="choices" cols="12" class="mb-2 d-flex justify-center">
          <v-row dense justify="center">
            <v-col v-for="c in choices" :key="c" cols="auto" class="d-flex justify-center">
              <v-btn
                small
                v-if="!photoUploading || !frameList.length"
                :color="
                  cleanChoiceLabel(c)
                    .toLowerCase()
                    .includes('no more items')
                    ? 'warning'
                    : isPhotoButton(c)
                    ? 'success'
                    : isPhoneButton(c)
                    ? 'warning'
                    : 'info'
                "
                class="choice-button"
                @click="selectChoice(c, isPhotoButton(c), isPhoneButton(c), isDemoButton(c))"
              >
                <v-icon v-if="isPhotoButton(c)" left>
                  mdi-video
                </v-icon>
                <v-icon v-if="isPhoneButton(c)" left>
                  mdi-phone-incoming
                </v-icon>
                {{ cleanChoiceLabel(c) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>

        <!-- <DynamicAiForm v-if="aiSchema" :schema="aiSchema" v-model="formData" :title="aiTitle" /> -->
        <v-card v-if="presentationSchema && drawer">
          <v-form-component
            ref="formComponent"
            :model="presentationModel"
            :vModel="presentationModel"
            :schema="presentationSchema"
            :data_object="{
              model: presentationModel,
              schema: presentationSchema
            }"
          ></v-form-component>
          <v-card-actions>
            <v-btn color="success">
              Confirm and Save
            </v-btn>
          </v-card-actions>
        </v-card>
        <AiDemo
          ref="aiDemo"
          v-if="showDemo"
          :actions="demoData.actions"
          @close="showDemo = false"
          @ask-demo="handleDemoRequest"
        />
        <!-- TEXT INPUT (CENTERED, FIXED WIDTH) -->
        <v-col cols="12" class="d-flex justify-center mt-n2">
          <v-text-field
            v-model="newMessage"
            class="mx-auto"
            :placeholder="
              defaultToolTip
                ? defaultToolTip
                : toolTip || 'Ask ' + capitalize(assistantModel ? assistantModel.name : '')
            "
            ref="userText"
            @keydown.enter="askAssistant()"
            v-if="chatReady && !loading && assistantId && !uploading && !photoTaken && !scanActive"
          >
            <!-- 📎 Upload (hidden if cameraButtons OR choices exist) -->
            <template #prepend>
              <template v-if="!cameraButtons">
                <v-tooltip bottom>
                  <template #activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="uploadImages = !uploadImages">
                      mdi-paperclip
                    </v-icon>
                  </template>
                  <span>{{ uploadImages ? "Hide Upload" : "Upload images" }}</span>
                </v-tooltip>
              </template>
            </template>

            <!-- 🎤 Speech -->
            <template #append-outer v-if="speechEnabled">
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="toggleSpeech" :color="isListening ? 'red' : 'grey'">
                    {{ isListening ? "mdi-microphone" : "mdi-microphone-outline" }}
                  </v-icon>
                </template>
                <span>{{ isListening ? "Stop listening" : "Start speech input" }}</span>
              </v-tooltip>
            </template>

            <!-- ➤ Send -->
            <template #append>
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="askAssistant()">
                    mdi-send
                  </v-icon>
                </template>
                <span>Send Request</span>
              </v-tooltip>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <input
        ref="photoInput"
        type="file"
        accept="image/*"
        capture="environment"
        @change="handleFileUpload"
        class="hidden-file-input"
      />

      <v-row v-if="scanActive" justify="center">
        <v-col cols="12" class="text-center">
          <PhotoVideo
            :portal_id="portal_id"
            :company_id="companyId"
            :user_id="user_id"
            @scanFinished="onScanFinished"
          />
        </v-col>
      </v-row>
    </v-container>

    <v-confirm ref="confirm"></v-confirm>
  </div>
</template>

<script>
import axios from "axios";
import * as fun from "../plugins/common";

import showdown from "showdown";
import io from "socket.io-client";
// import VoiceClient from "@/voice/VoiceClient";
import VoiceClient from "@/voice/VoiceClientWhisper";
export default {
  props: {
    hideAssistantsList: Boolean,
    hideNewChat: Boolean,
    hideThreads: Boolean,
    defaultMessage: String,
    defaultToolTip: String,
    // customInstructions: String,
    listHeight: Number,
    noStreaming: Boolean,
    existingThreadId: String,
    objectAssistantId: String,
    dataObject: Object,
    getData: String
  },
  data: () => ({
    simulatorMessage: null,
    autoSimulate: false,
    disabled_functions: [],
    availableFunctions: "",
    assistantList: true,
    assistant_id: "",
    assistantName: "",
    initialMessage: "",
    assistantModel: null,
    assistantId: "",
    threads: [],
    thread_id: "",
    instructions: "",
    newMessage: "",
    hasInitialMessage: false,
    msgKey: 0,
    headers: null,
    models: [],
    messages: [],
    chats: [],
    delay: 0,
    return_json: false,
    // rules: [(v) => !!v || "Input is required"],
    socket: null,
    // url: "https://api.openai.com/v1/chat/completions",
    url: "http://localhost:5001/completions",
    chatGPT: false,
    session: new Date(),
    user_id: "",
    resendInterval: 20000,
    loading: false,
    errorMessage: "",
    gptMessages: [],
    totalPrice: 0,
    totalTokens: 0,
    systemMessage: {},
    functions: [],
    chatReady: false,
    userData: {},
    currentFunction: "",
    excludedData: [],
    addresses: [],
    tools: [],
    dialog: 0,
    shipmentKey: 0,
    charges: null,
    shipmentReady: false,
    runningFunction: false,
    streaming: "",
    model: null,
    simulation: false,
    my_location: "",
    clear: false,
    speechEnabled: false,
    loadingText: "",
    defaultLoadingText: "Your message is received and processing... Click to resend",
    companyName: "Four Winds Relocation LLC",
    companyId: "5de16757bec0b423ddcd3507",
    portal_id: "85",
    cancelTokenSource: null,
    successMessage: "",
    captionPrompt__:
      "Also, please create a curEst for the task. Provide the caption as an annotation in the format: <annotation type='caption'>[Your caption here]</annotation> without including the annotation in your response",
    captionPrompt_:
      "Also, please create a caption for the task. Provide the caption as an annotation without including the annotation in your response",
    caption: "",
    updateServer: false,
    additionalStructure: null,
    functionDescription: {
      get_geo: "Validating Address",
      submit_lead: "Updating your shipment information",
      calculate_shipment: "Calculating Your Move",
      book_lead: "Booking Your Move",
      get_web_info: "Getting info from the web...",
      web_lookup: "Getting info from the web...",
      export_pipeline_to_excel: "Creating Excel Spreasheet"
    },
    actionMessage: "",
    actionImage: "",
    defaultActionImage: "brainstorming.gif",
    defaultActionMessage: "Analyzing your input...",
    createdCaption: "",
    formModel: {},
    uploadImages: false,
    uploading: false,
    images: [
      // "https://portal85.moverai.com/user_images/portal_85/bedroom.jpg",
      // "https://portal85.moverai.com/user_images/portal_85/bedroom2.jpg",
    ],
    routeId: "",
    timeStarted: 0,
    timeFinished: 0,
    timeElaspsed: 0,
    voice: null,
    vc: null,
    voiceActive: false,
    uploadKey: 0,
    dropTarget: null,
    toolTip: "",
    initialized: false,
    defaultAssistantId: "53cdc19fad0e9703f3700596",
    generatedMessage: "",
    editMode: false,
    instructionModel: null,
    schema: null,
    formKey: 0,
    aiTitle: "Review Company Information",
    aiSchema: null,
    aiModel: null,
    objectName: "",
    drawer: false,
    formBuffer: "",
    isCapturingForm: false,
    videoStream: null,
    videoEl: null,
    scanActive: false,
    scanInterval: null,
    scanSeconds: 0,
    scanCountdownTimer: null,
    showDemo: false,
    demoData: null,
    scanConfirmVisible: false,
    scanFrameInterval: 1200, // ms between frames
    presentationModel: null,
    presentationSchema: null,
    extra: null,
    initialzing: false,

    // aiSchema: {
    //   company_name: {
    //     title: "Company Name",
    //     type: "string"
    //   },
    //   website: {
    //     title: "Website",
    //     type: "string"
    //   },
    //   phone: {
    //     title: "Phone",
    //     type: "string"
    //   },
    //   active: {
    //     title: "Active",
    //     type: "boolean",
    //     "x-display": "v-switch"
    //   }
    // },
    // aiModel: {
    //   company_name: "ABC Moving LLC",
    //   website: "https://abcmoving.com",
    //   phone: "+1 555 123 4567"
    // },
    customSuccessMessage: "Uploaded. Upload more files or click Send Button when ready",
    customerAssistantId: "aa0880488d514760b5753429",
    choiseRules: `CHOICE USAGE RULE:
    [choices: ...] MUST be used ONLY when:
    • The user must choose between predefined options
    • The answer space is CLOSED
    • Clicking avoids typing
    [choices: ...] MUST NOT be used for:
    • Data entry (name, email, phone, address)
    • Open-ended explanations
    • Meta actions
    CHOICE FORMAT:
    [choices: option1 | option2 | option3] Never omit separator |. Separator | must always present. Omiting it will lead to an error on front end and make a call invalid
    • Must be the last line of the message
    • Max 6 options
    • Options must be short (1–5 words)
    • No punctuation inside options


`,
    adminMessage: "",
    letterTest: "",
    cameraButtons: "",
    frameList: [],
    maxPhotos: 4,
    photoUploading: false,
    photoTaken: false,
    indvidualItems: false,
    conversation_id: null
  }),

  components: {
    // eslint-disable-next-line vue/no-unused-components
    // VShipment: () => import("@/views/Shipment.vue"),
    VConfirm: () => import("@/components/Confirm.vue"),
    VUpload: () => import("@/components/UploadDragDrop.vue"),
    PhotoVideo: () => import("@/components/PhotoVideo.vue"),
    // DynamicAiForm: () => import("@/components/DynamicAiForm.vue"),

    VFormComponent: () => import("@/components/FormComponent.vue"),
    AiDemo: () => import("@/components/AiDemo.vue")
    // VLoadingIcon: () => import("@/components/LoadingIcon.vue")
  },
  beforeRouteEnter(to, from, next) {
    next(that => {
      that.initChat();
    });
  },

  created() {},
  mounted() {
    this.initiateChat();
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.off("chunk_received", this.onChunkReceived);
      this.socket.disconnect();
      this.socket = null;
    }
  },

  methods: {
    clearCache() {
      window.localStorage.clear();
      window.location.reload();
    },
    getLocation(f) {
      var that = this;
      navigator.geolocation.getCurrentPosition(
        async pos => {
          try {
            var data = {
              lat: pos.coords.latitude,
              lng: pos.coords.longitude
            };

            axios.post(this.serverURL + "/get_city_state", data, {}).then(res => {
              console.log(res);
              that.my_location = res.data.city + ", " + res.data.state;
              f();
            });
          } catch (err) {
            this.locationError = "Failed to get location";
          } finally {
            this.loadingLocation = false;
          }
        },
        err => {
          this.loadingLocation = false;
          this.locationError = "Permission denied";
        }
      );
    },
    initiateChat() {
      this.editMode = window.location.host.indexOf("localhost") != -1;
      this.initialzing = true;
      var that = this;
      // if (!that.chat_id) {
      var id = that.$router.currentRoute.params.id;
      if (id) {
        try {
          that.assistantId = id.split("-")[0];
          that.portal_id = id.split("-")[1];
          that.companyId = id.split("-")[2];
          that.order_id = id.split("-")[3];
        } catch (error) {
          //
        }
      }
      if ((!id || !that.companyId || !that.portal_id) && !that.assistantId) {
        that.assistantId = null;
        that.initChat();
      }
    },
    onScanFinished(images) {
      this.images = images;

      if (images && images.length) {
        this.newMessage = "Scan inventory photos";

        this.askAssistant();
      }

      this.scanActive = false;
    },
    handleDemoRequest(extra) {
      this.callOpenAI(false, false, null, extra);
    },
    sendAdminOverride() {
      if (!this.adminMessage.trim()) return;

      this.askAssistant(false, {
        admin: true,
        systemOverride: `[DEV OVERRIDE]\n${this.adminMessage}`
      });

      this.adminMessage = "";
    },
    requestCall() {
      var data = {
        user: this.user_id,
        action: "call_request",
        portal: this.portal_id,
        shipment_id: this.existingShipment?.shipment_id
      };

      this.saveMessages(userMessage);

      axios.post(this.serverURL + "/send_message", data, {}).then(response => {
        this.successMessage = "Call Is Requested! Someone will be calling you shortly";
      });
      var userMessage = {
        content: "call_request",
        thread_id: this.thread_id,
        role: "user"
      };
    },
    selectChoice(text, isPhoto = false, isCallRequest = false, isDemo = false) {
      const value = text.toLowerCase().trim();

      // 📞 Phone request
      if (isCallRequest) {
        this.requestCall();
        return;
      }

      // 📷 Upload / send photos keywords
      if (value.includes("upload") || value.includes("send photos")) {
        this.uploadImages = true;
        return;
      }
      if (isDemo) {
        console.log("demo");
        this.newMessage = text;
        this.extra = {
          demo_mode: true,
          goal: text.replace("demo_", "")
        };
        this.askAssistant();
        return;
      }
      // 💬 Normal text choice
      if (!isPhoto) {
        this.newMessage = text;
        if (value == "start demo") {
          this.demoData = {};
          this.showDemo = true;
          // this.$nextTick(() => {
          //   this.$refs.aiDemo?.start();
          // });
        }
        this.askAssistant();
        return;
      }

      // 📸 Camera button flow
      this.newMessage = text.replace(/camera_button/i, "").trim();
      this.indvidualItems = false;

      if (this.newMessage === "individual items") {
        this.maxPhotos = 10;
        this.indvidualItems = true;
      } else {
        this.maxPhotos = 4;
      }

      this.triggerPhotoInput();
    },
    initChat() {
      var that = this;

      this.initSocket();
      if (that.$root.portal_id && that.$root.portal_id != "admin") {
        that.portal_id = that.$root.portal_id;
      }

      that.$root.$on("gotFiles", f => {
        console.log(f);
      });
      that.cancelTokenSource = null;

      that.focusOnText();

      if (that.objectAssistantId) {
        that.assistantId = that.objectAssistantId;
      }

      if (that.assistantId) {
        that.assistantList = false;
      }

      that.$root.$on("fileUploaded", d => {
        that.images.push(fun.filePathToUrl(d.response.path.replace("\public", "")));
        that.uploading = false;
      });
      that.$root.$on("fileDeleted", d => {
        let index = that.images.indexOf(d.file.path);

        if (index !== -1) {
          that.images.splice(index, 1);
        }
      });

      if (that.$root.user_id) {
        that.user_id = that.$root.user_id;
      } else {
        that.user_id = localStorage.getItem("user_id");
        if (!that.user_id) {
          that.user_id = fun.guid();
          localStorage.setItem("user_id", that.user_id);
          that.user_id = localStorage.getItem("user_id");
        }
      }
      that.formModel._id = that.user_id;

      if (that.speechEnabled) {
        that.speechToText();
      }
      document.arrive("div", a => {
        if (a) {
          that.scrollToBottom();
        }
      });
      this.conversation_id = localStorage.getItem("conversation_id");
      if (!this.conversation_id) {
        this.conversation_id = fun.guid();
        localStorage.setItem("conversation_id", this.conversation_id);
      }

      that.getAssistants();
    },
    onChunkReceived(d) {
      var that = this;
      this.extra = null;
      // console.log(d);
      that.timeFinished = new Date();
      if (!that.timeElaspsed) {
        that.timeElaspsed = (that.timeFinished - that.timeStarted) / 1000;
        // that.streaming = "(Thought " + that.timeElaspsed + " s.)<br>";
      }

      var systemMessage = {};
      if (that.user_id == d.user) {
        if (d.caption) {
          console.log(d.caption);
          that.caption = d.caption;
        }
        if (d.json) {
          d.userMessage = this.newMessage;
          that.$root.$emit("responseFromAssistant", d);
          systemMessage = {
            content: that.streaming,
            thread_id: that.thread_id,
            role: "assistant"
          };
          systemMessage = {
            // content: that.streaming + JSON.stringify(d.json),
            thread_id: that.thread_id,
            role: "assistant"
          };

          that.loading = false;
          // that.messages.push(systemMessage);

          return;
        }
        if (d.action === "present_structured_form") {
          that.aiTitle = d.action_data.title || "Review Data";
          that.presentationSchema = d.action_data.schema;
          that.presentationModel = d.action_data.model;

          that.loading = false;
          that.drawer = true;
          systemMessage = {
            content: d.action_data.message,

            role: "assistant"
          };

          // systemMessage.content = this.extractJsonForm(systemMessage.content);
          that.messages.push(systemMessage);
          that.saveMessages(systemMessage);

          that.focusOnText();
          that.scrollToBottom();
          that.chatReady = true;
        }
        if (d.action === "run_demo") {
          this.demoData = d.action_data;
          this.showDemo = true;
        }
        if (d.action === "demo_step") {
          this.$refs.aiDemo?.runStep(d.action_data);
          return;
        }
        if (d.end_of_stream) {
          //
          that.loading = false;
          // The terminal event includes the complete response as a recovery path
          // when a proxy or socket reconnect drops the preceding text chunks.
          if (d.full_text && !String(that.streaming || "").trim()) {
            that.streaming = d.full_text;
            that.formBuffer = d.full_text;
          }
          that.uploadImages = false;
          that.uploadKey = !that.uploadKey;
          that.photoUploading = false;
          that.photoTaken = false;
          that.frameList = [];
          that.images = [];
          // if (that.streaming.toLocaleLowerCase().includes("upload images")) {
          //   // that.uploadImages = true;
          //   that.images = ["https://portal85.moverai.com/user_images/room.jpg"];
          // }

          // that.thread_id = d.thread_id;
          // that.systemMessage.thread_id = that.thread_id;
          // if (d.json) {
          //   that.streaming = d.json;
          // }
          systemMessage = {
            content: that.streaming,
            thread_id: that.thread_id,
            role: "assistant"
          };

          if (systemMessage.content) {
            // systemMessage.content = this.extractJsonForm(systemMessage.content);
            that.messages.push(systemMessage);
            that.saveMessages(systemMessage);

            that.focusOnText();
            that.scrollToBottom();
            that.chatReady = true;
            that.$root.$emit("generationDone", { obj: that });
            if (that.assistantModel.simulation_mode) {
              if (that.simulate) {
                this.simulatorMessage = fun.clone(systemMessage.content);
              }

              if (that.assistantModel.autoSimulate) {
                setTimeout(that.callSimulator(), 6000);
              }

              ///
            }

            // that.msgKey = !that.msgKey;
          }
        } else {
          if (d.running_function) {
            var action = this.functionDescription[d.running_function];
            if (action) {
              that.actionImage = d.running_function + ".gif";
            } else {
              action = "Thinking";
            }

            var description = action;

            that.actionMessage = description + "...";
          } else {
            that.actionMessage = this.defaultActionMessage;
            that.actionImage = this.defaultActionImage;
            that.runningFunction = false;
            // setTimeout(function () {

            // that.streaming = that.streaming + d.text;
            that.formBuffer += d.text;
            that.extractJsonForm();
            if (that.streaming?.startsWith("null")) {
              that.streaming = that.streaming.slice(4);
            }

            that.thread_id = d.thread_id;
            that.createdCaption = d.caption;
            if (that.messages.length == 1) {
              that.messages[0].thread_id = that.thread_id;
            }
            if (that.assistantModel.output_function) {
              if (that.streaming.startsWith("```html") || that.streaming.startsWith("<!DOCTYPE HTML>")) {
                that.$root.$emit(that.assistantModel.output_function, { value: that.streaming, obj: that });
              }
            }
            that.scrollToBottom();
          }
        }
      }
    },
    extractJsonForm() {
      var that = this;
      if (that.formBuffer) {
        const text = that.formBuffer;

        // If currently capturing form JSON
        if (that.isCapturingForm) {
          // that.formBuffer += text;

          // Check for end marker
          if (that.formBuffer.includes("json_form_end")) {
            that.isCapturingForm = false;

            // Extract JSON between markers
            const match = that.formBuffer.match(/json_form_start\s*([\s\S]*?)\s*json_form_end/);

            if (match) {
              try {
                const parsed = JSON.parse(match[1].trim());

                that.objectName = parsed.object || null;
                if (that.additionalStructure[that.objectName]) {
                  that.aiModel = {};
                  that.aiModel[that.objectName] = parsed.model;
                  that.aiSchema = {};
                  that.aiSchema[that.objectName] = that.additionalStructure[that.objectName];
                }

                that.drawer = true;
              } catch (e) {
                console.error("Invalid streamed JSON:", e);
              }
            }

            // Clear buffer
            that.formBuffer = "";
          }
        } else {
          // Not capturing yet
          if (text.includes("json_form_start")) {
            that.isCapturingForm = true;

            // Split text at start marker
            const parts = text.split("json_form_start");

            // Everything before marker goes to normal streaming
            that.streaming += parts[0];

            // Everything after marker starts form buffer
            that.formBuffer += parts[1];
            this.streaming = this.streaming.replace("json_form", "");
          } else {
            // Normal text
            that.streaming = that.formBuffer;
          }
        }
      }
    },
    extractJsonForm_(text) {
      const regex = /json_form_start\s*([\s\S]*?)\s*json_form_end/;
      const match = text.match(regex);

      if (!match) {
        return text;
      }

      const jsonString = match[1].trim();

      try {
        const parsed = JSON.parse(jsonString);

        this.aiModel = parsed.model || {};
        this.objectName = parsed.object || null;

        // Open form drawer
        this.drawer = true;
      } catch (e) {
        console.error("Invalid JSON inside form block:", e);
        return text;
      }

      // Remove JSON block from message
      return text.replace(regex, "").trim();
    },

    testLetterParser(data) {
      axios
        .post(this.serverURL + "/test_letter_parser", data, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
          this.letterTest = response.data;
        });
    },
    openPhotoPicker() {
      const input = this.$refs.photoInput;
      input.value = "";
      input.click();
    },

    handleFileUpload(event) {
      this.inventoryReady = false;

      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      reader.onload = e => {
        const img = new Image();

        img.onload = () => {
          const srcW = img.width;
          const srcH = img.height;

          const maxSide = 896;
          const scale = Math.min(1, maxSide / Math.max(srcW, srcH));
          const w = Math.round(srcW * scale);
          const h = Math.round(srcH * scale);

          // const canvas = document.createElement("canvas");
          const canvas = this.$refs.canvas;

          canvas.width = w;
          canvas.height = h;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, w, h);

          const quality = 0.4;

          canvas.toBlob(
            blob => {
              if (!blob) return;

              // Optional: preview in chat before upload
              const previewUrl = URL.createObjectURL(blob);

              if (this.frameList.length < this.maxPhotos) {
                this.frameList.push(previewUrl);
                this.flashActive = true;
                setTimeout(() => (this.flashActive = false), 300);

                // ⬇️ upload resized image
                this.photoUploading = true;
                this.photoTaken = true;
                this.uploadPhoto(blob);
              } else {
                this.errorMessage = "Maximum of " + this.maxPhotos + " images allowed";
              }
            },
            "image/jpeg",
            quality
          );
        };

        img.src = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    finishScan() {
      this.scanConfirmVisible = false;

      this.stopVideoScan();
    },
    uploadPhoto(blob) {
      const formData = new FormData();
      var portal = `portal_${this.portal_id}`;

      // give server a proper filename
      const fileName = `aichat_${Date.now()}.jpg`;
      formData.append("file", blob, fileName);
      formData.append("portal", portal);
      formData.append("record_id", this.order_id);
      formData.append("object_name", "shipment");
      //
      axios
        .post(fun.getServerURL("aichat") + "/upload_file", formData)

        .then(d => {
          if (!d || !d.data || !d.data.path) return;
          // function stripBeforePublic(path) {
          //   const key = "\\public";
          //   const idx = path.toLowerCase().indexOf(key);

          //   if (idx === -1) return path; // no "public" → return as-is

          //   return path.slice(idx + key.length);
          // }

          const url = fun.filePathToUrl(d.data.path);

          this.images.push(url);
        })
        .catch(err => {
          console.error("Upload failed:", err);
          this.errorMessage = "Image upload failed";
        });
    },

    askAssistant(gen, sys, savedConversation) {
      const that = this;
      this.formBuffer = "";

      this.scrollToBottom();

      const isAdmin = sys?.admin === true;
      if (isAdmin) {
        this.newMessage = sys.systemOverride;
      }

      // if (!content || !content.trim()) return;

      // const message = {
      //   role: isAdmin ? "system" : "user",
      //   content,
      //   thread_id: this.thread_id,
      //   admin: isAdmin === true
      // };

      this.timeStarted = new Date();
      this.timeFinished = 0;
      this.timeElapsed = 0;
      this.loading = true;

      this.$nextTick(() => {
        this.initialzing = false;
        that.callOpenAI(gen, isAdmin, savedConversation);
      });
      this.toolTip = this.defaultToolTip;

      // if (!isAdmin) {
      //   this.newMessage = "";
      // }
    },
    // initSocket() {
    //   if (this.socket) return;

    //   const socketUrl = "https://server.moverai.com:5000";
    //   this.socket = io(socketUrl);

    //   this.socket.on("chunk_received", this.onChunkReceived);
    // },
    initSocket() {
      var that = this;
      if (this.socket) return;

      // Chat requests and streamed replies must use the same server. Borrowing the
      // app-wide socket can route localhost requests to a production socket room.
      this.socket = io("https://server.moverai.com:5000");

      this.socket.on("connect", () => {
        console.log("✅ Socket connected:", this.socket.id);
        console.log("SOCKET NAMESPACE:", this.socket.nsp);

        that.socket.emit("register", {
          user: that.user_id
        });
      });

      this.socket.on("chunk_received", payload => {
        console.log(payload);
        if (!payload.assistant || payload.assistant == that.assistantId) {
          that.onChunkReceived(payload);
        }
      });

      this.socket.on("assistant_done", () => {
        this.onAssistantDone();
      });

      this.socket.on("assistant_stopped", () => {
        this.onAssistantStopped();
      });
    },

    waitForSocketConnection(timeout = 10000) {
      this.initSocket();

      if (this.socket && this.socket.connected && this.socket.id) {
        return Promise.resolve(this.socket.id);
      }

      return new Promise((resolve, reject) => {
        const timer = setTimeout(() => {
          cleanup();
          reject(new Error("Unable to connect to the assistant stream."));
        }, timeout);

        const cleanup = () => {
          clearTimeout(timer);
          this.socket.off("connect", onConnect);
          this.socket.off("connect_error", onError);
        };
        const onConnect = () => {
          cleanup();
          resolve(this.socket.id);
        };
        const onError = error => {
          cleanup();
          reject(error || new Error("Unable to connect to the assistant stream."));
        };

        this.socket.once("connect", onConnect);
        this.socket.once("connect_error", onError);
        if (!this.socket.connected) this.socket.connect();
      });
    },

    focusOnText() {
      this.$nextTick(() => {
        if (this.$refs.userText) {
          this.$refs.userText.focus();
        }
      });
    },
    capitalize(text) {
      return fun.capitalize(text);
    },
    isPhotoButton(choice) {
      return /^\[?camera_button\]?/i.test(choice.trim());
    },

    isPhoneButton(choice) {
      return /^\[?phone_button\]?/i.test(choice.trim());
    },
    isDemoButton(choice) {
      return /^\[?demo\]?/i.test(choice.trim());
    },
    cleanChoiceLabel(choice) {
      return choice
        .replace(/^camera_button\s*/i, "")
        .replace(/^phone_button\s*/i, "")
        .replace(/^demo_\s*/i, "");
    },
    getCompany() {
      var data = {
        object_name: "company",
        db_name: "emover_" + this.portal_id,
        // all_records: true,
        keep_portal: true,
        qry: { is_default: true, active: true }
      };
      axios
        .post(this.serverURL + "/get_data", data, {
          withCredentials: true
        })
        .then(response => {
          var data = response.data;
          try {
            this.company = data.model[0];
            this.companyName = this.company.company_name;
            this.companyId = this.coompany._id;
          } catch (error) {
            //
          }

          console.log(data);
        });
    },
    getMessages(a) {
      var that = this;
      if (!a.record_id) {
        return;
      }
      var data = {
        object_name: "ai_messages",
        qry: {
          $and: [
            { user_id: this.user_id },
            { assistant_id: a.record_id }
            // { thread_id: this.existingThreadId || 0 }
            // { thread_id: { $exists: true, $ne: null } }, // ✅ exists and not null
          ]
        },

        db_name: "admin"
      };
      axios
        .post(this.serverURL + "/get_data", data, {
          withCredentials: true
        })
        .then(response => {
          // setTimeout((this.chatReady = true), 1000);

          var data = response.data;
          if (data.model && data.model.length) {
            var grouped = data.model.reduce((acc, item) => {
              acc[item.thread_id] = acc[item.thread_id] || item;
              return acc;
            }, {});

            that.threads = grouped;
            that.messages = data.model;
            var threads = Object.keys(that.threads);
            if (threads.length) {
              if (!this.existingThreadId) {
                if (!this.hideAssistantsList) {
                  that.selectThread(threads[threads.length - 1]);
                }
              } else {
                that.selectThread(
                  threads.find(t => {
                    t.thread_id == this.existingThreadId;
                  })
                );
              }
            }
          }
        });
    },
    selectThread(thread_id) {
      this.thread_id = thread_id;

      // this.messages
      //   .filter((m) => {
      //     return m.thread_id == this.thread_id;
      //   })
      //   .forEach((m) => {
      //     var msg = {
      //       _id: m._id,
      //       thread_id: this.thread_id,
      //       icon: m.role == "user" ? "mdi-account-circle" : "mdi-assistant",
      //       text: m.content,
      //       iconColor: m.role == "user" ? "primary" : "#F5F5F5",
      //       color: "white",
      //     };
      //     if (
      //       this.messages.some((r) => {
      //         return r._id != m._id;
      //       })
      //     ) {
      //       this.messages.push(msg);
      //     }
      //   });
    },
    initEventSource() {
      const evtSource = new EventSource(this.serverURL + "/assistant_stream");
      evtSource.onmessage = event => {
        console.log(JSON.parse(event.data));
      };
    },
    selectAssistant(a) {
      // if (!this.customInstructions) {
      if (a.message) {
        this.instructions = a.message
          .replace("[company_name]", this.companyName)
          .replace("[company_id]", this.companyId)
          .replace("[portal_id]", this.portal_id)
          .replace("[my_location]", this.my_location);
        // } else {
        //   this.instructions = this.customInstructions;
        // }
      }

      this.instructions += " Today is " + fun.getFullDate(new Date());

      this.assistantName = a.name;

      if (a.functions) {
        this.tools = this.tools.filter(
          tool =>
            tool &&
            tool.function &&
            a.functions.split(",").includes(tool.function.name) &&
            !this.assistantModel.disabled_functions.includes(tool.function.name)
        );
      }
      this.tools.push({
        type: "file_search"
      });
      this.tools.push({
        type: "file_search"
      });
      var file_ids = a.file_ids ? a.file_ids.split(",") : [];
      var tool_resources = { code_interpreter: { file_ids: file_ids } };
      var data = {
        _id: a._id,
        assistant_id: a.assistant_id,
        name: a.name,
        message: this.instructions,
        tools: this.tools,
        tool_resources: tool_resources,
        model: "gpt-4o-mini"
        // model: "gpt-5.1",
      };
      axios
        .post(this.serverURL + "/select_assistant", data, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
          if (response.data.error) {
            // this.errorMessage = response.data.error;
            return;
          }
          this.assistant_id = response.data.assistant_id;
          this.chatReady = true;

          this.scrollToBottom();
          this.focusOnText();
        });
    },
    getModels() {
      var headers = this.headers;
      var that = this;
      axios.get("https://api.openai.com/v1/models", { headers: headers }).then(resp => {
        console.log(resp);
        resp.data.data.forEach(m => {
          that.models.push(m.id);
        });
      });
    },
    scrollToBottom() {
      const messageList = document.getElementById("message-list");

      try {
        messageList.scrollTop = messageList.scrollHeight;
        // console.log("scrolled", messageList.scrollHeight);
      } catch (error) {
        // console.log(error);
        // console.log("scrolled", "error");
        //
      }
    },

    reload(c) {
      window.speechSynthesis.cancel();
      this.loading = false;
      if (c) {
        this.clear = true;
      }

      this.errorMessage = "";
      this.gptMessages = [];
      this.messages = [];
      this.getAssistants();
    },

    getAssistants() {
      // this.newMessage = this.defaultMessage;
      let companyQry = { is_default: true, active: true };
      if (this.companyId) {
        companyQry = { _id: this.companyId };
      }
      var that = this;
      let data = {
        object_name: "chat_settings",
        all_records: true,
        db_name: "admin",
        additional_structure: [
          {
            obj_name: "company"
          }
        ],

        additional_data: [
          {
            obj_name: "company",
            db_name: "emover_" + this.portal_id,
            fields: ["_id", "company_name"],

            keep_portal: true,
            qry: companyQry
          },
          {
            obj_name: "material_list",
            db_name: "emover_" + this.portal_id,
            fields: ["material_name", "cu_ft"],
            qry: {
              cu_ft: {
                $exists: true,
                $nin: [null, 0]
              }
            },
            keep_portal: true
          }
        ]
      };

      axios
        .post(this.serverURL + "/get_data", data, {
          withCredentials: true
        })
        .then(response => {
          // setTimeout((this.chatReady = true), 1000);
          var data = response.data;
          this.chats = data.model;
          if (!that.assistantId) {
            that.assistantId = that.defaultAssistantId;
          }
          if (that.assistantId) {
            that.assistantModel = data.model.find(m => {
              return m._id == that.assistantId;
            });
            if (that.assistantModel.display_assistant_name) {
              that.assistantName = that.assistantModel.name;
            }
            try {
              if (that.assistantModel.functions) {
                that.availableFunctions = that.assistantModel.functions.split(",");
                // that.assistantModel.disabled_functions = that.disabled_functions;
              }
            } catch (error) {
              //
            }

            that.instructionModel = { message_sections: that.assistantModel.message_sections };
            that.schema = { message_sections: response.data.schema.properties.message_sections };
          }

          that.company = data.additional_model.company[0];
          that.additionalStructure = data.additional_structure;

          that.companyName = that.company?.company_name;
          that.companyId = that.company?._id;
          that.instructions = that.choiseRules;
          if (that.assistantModel.message_sections && that.assistantModel.message_sections.length) {
            fun.sortObjects(that.assistantModel.message_sections, "order");
            that.assistantModel.message_sections.forEach(inst => {
              if (!inst.disabled) {
                that.instructions += inst.title + ": " + inst.content;
              }
            });
          } else {
            that.instructions = that.assistantModel?.message;
          }
          // that.assistantModel.show_all_threads = false;
          that.instructions = that.instructions
            .replaceAll("[company_name]", that.companyName)
            .replaceAll("[company_id]", that.companyId)
            .replaceAll("[portal_id]", that.portal_id);

          try {
            //data.additional_model
            data.additional_model.material_list = data.additional_model.material_list.map(
              ({ _id, material_name, ...rest }) => ({
                ...rest,
                material_name: material_name ? `${material_name} (PBC)` : material_name
              })
            );

            that.instructions = that.instructions.replace(
              "[material_list]",
              JSON.stringify(data.additional_model.material_list)
            );
          } catch (error) {
            //
          }

          if (that.getData) {
            if (localStorage.getItem(that.getData)) {
              that.getData = localStorage.getItem(that.getData);
            }
            that.instructions = that.instructions.replaceAll("[customData]", that.getData);
          }
          that.toolTip = that.assistantModel?.tool_tip;

          that.initialMessage = that.assistantModel?.initial_message?.replaceAll("[company_name]", that.companyName);

          // if (that.companyName && that.assistantModel && that.assistantModel.text == "Customer Assistant") {

          // } else if (that.assistantModel) {
          //   that.initialMessage += that.assistantModel.initial_message;
          // }
          if (this.defaultMessage) {
            this.initialMessage = this.defaultMessage;
          }
          try {
            // that.getFunctions();
            if (!that.assistantModel.return_json) {
              this.getMessages(that.assistantModel);
            }
          } catch (error) {
            //
          }
          if (that.assistantModel?.functions) {
            that.tools = that.assistantModel.functions.split(",");
          }

          // that.captionPrompt =
          //   that.assistantModel.getCaptionPrompt + this.captionInstructions;
          this.loading = false;
          this.initialzing = false;
          this.chatReady = true;
          var savedConversation = null;
          if (
            that.assistantModel?.initial_message_to_send &&
            !that.assistantModel?.first_message_off &&
            !that.messages.length
          ) {
            that.hasInitialMessage = true;
            that.initialzing = true;

            if (that.assistantModel?.initial_message_to_send.includes("[my_location]")) {
              that.getLocation(f => {
                that.newMessage = that.assistantModel?.initial_message_to_send.replaceAll(
                  "[my_location]",
                  that.my_location
                );
                if (that.conversation_id) {
                  savedConversation = localStorage.getItem(that.conversation_id);
                }

                that.askAssistant(false, null, savedConversation);
              });
            } else {
              that.newMessage = that.assistantModel.initial_message_to_send;
              if (this.assistantId == this.customerAssistantId) {
                if (!this.order_id) {
                  // var newShipment = {
                  //   shipment_data: {
                  //     _id: `_new_${fun.guid()}`
                  //   }
                  // };
                  // that.newMessage = "my new move " + JSON.stringify(newShipment);
                  that.newMessage = "I need an estimate on my move";
                  that.askAssistant();
                } else {
                  data = {
                    object_name: "shipment",
                    db_name: "emover_" + this.portal_id,
                    // all_records: true,
                    keep_portal: true,
                    qry: { _id: this.order_id }
                  };
                  axios
                    .post(this.serverURL + "/get_data", data, {
                      withCredentials: true
                    })
                    .then(response => {
                      console.log(response.data);
                      let existingShipment = response.data.model[0];
                      this.existingShipment = existingShipment;
                      that.hasInitialMessage = true;
                      this.formattedShipment = fun.extractLeadDataFromExistingShipment(
                        existingShipment,
                        this.portal_id
                      );
                      that.newMessage = "my existing move " + JSON.stringify(this.formattedShipment);
                      // that.instructionthat.instructions.replaceAll();
                      that.generatedMessage = fun.clone(that.newMessage);

                      if (that.order_id) {
                        savedConversation = localStorage.getItem(that.order_id);
                      }

                      that.askAssistant(true, null, savedConversation);
                      // that.testLetterParser(existingShipment);
                    });
                }
              } else {
                that.askAssistant(false, null, savedConversation);
              }
            }
          }
        });
    },
    convertMarkdownLinksToHTML(text) {
      if (!text || typeof text !== "string") {
        return { html: "", choices: null, cameraButtons: null };
      }

      // ---- CHOICES EXTRACTION (BEFORE MARKDOWN)
      const choicesRegex = /\[choices:\s*([^\]]+)\]\s*$/i;
      let choices = null;
      let cameraButtons = null;
      let phoneButtons = null;

      const choiceMatch = text.match(choicesRegex);
      if (choiceMatch) {
        const rawChoices = choiceMatch[1]
          .split("|")
          .map(c => c.trim())
          .filter(Boolean);

        const CAMERA_RE = /^\[camera_button\]/i;
        const PHONE_RE = /^\[phone_button\]/i;

        cameraButtons = rawChoices.filter(c => CAMERA_RE.test(c)).map(c => c.replace(CAMERA_RE, "").trim());

        phoneButtons = rawChoices.filter(c => PHONE_RE.test(c)).map(c => c.replace(PHONE_RE, "").trim());

        choices = rawChoices.filter(c => !CAMERA_RE.test(c) && !PHONE_RE.test(c));

        if (!choices.length) choices = null;
        if (!cameraButtons.length) cameraButtons = null;
        if (!phoneButtons.length) phoneButtons = null;

        text = text.replace(choiceMatch[0], "").trim();
      }

      // ---- REMOVE CAPTION PROMPT
      text = text.replace(this.captionPrompt, "");

      // ---- MARKDOWN LINKS
      const linkRegex = /\[([^\]]+)]\(([^)]+)\)/g;
      text = text.replace(linkRegex, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');

      // ---- MARKDOWN TO HTML
      const converter = new showdown.Converter();
      text = converter.makeHtml(text);
      text = text.split("\u001b").join("");
      // ---- REMOVE EMPTY PARAGRAPHS
      text = text.replace(/<p>\s*<\/p>/g, "");

      // ---- STRUCTURED LIST VALUE HIGHLIGHTING
      text = text.replace(/^([^:<\n]+):\s*(.+)$/gm, (_, label, value) => `${label}: <strong>${value}</strong>`);

      // ---- CHAT CAPTION EXTRACTION
      const captionRegex = /<chat_caption>(.*?)<\/chat_caption>/g;
      const match = captionRegex.exec(text);
      if (match) {
        this.caption = match[1];
        text = text.replace(captionRegex, "");
      }

      // ---- STATE
      this.choices = choices;
      this.cameraButtons = cameraButtons;
      if (choices || cameraButtons) {
        this.toolTip = "or type something else";
      }

      return {
        html: text,
        choices,
        cameraButtons
      };
    },

    isCameraRoomChoice(choice) {
      return choice.startsWith("[CAMERA_ROOM]");
    },

    getRoomLabel(choice) {
      return choice.replace("[CAMERA_ROOM]", "").trim();
    },

    stopAssistant() {
      this.loading = false;
      axios
        .post(
          this.serverURL + "/stop_assistant",
          {},
          {
            withCredentials: true
          }
        )
        .then(response => {
          this.successMessage = response.data.message;
        });
    },
    deleteThread(t) {
      var that = this;

      this.$refs.confirm
        .open("Delete Thread", "Confirm deleting " + t.caption + "?", {
          color: "red"
        })
        .then(confirm => {
          if (confirm) {
            this.loading = true;
            axios
              .post(this.serverURL + "/delete_thread", {
                thread_id: t.thread_id
              })
              .then(response => {
                this.loading = false;
                // console.log(response.data);
                delete that.threads[t.thread_id];
                this.messages = [];
                this.getAssistants();

                // that.threads = that.threads.filter((a) => {
                //   return a.thread_id != t.thread_id;
                // });
              });
          }
        });

      //
    },
    triggerPhotoInput() {
      // this.$refs.photoInput.click();
      // this.startVideoScan();
      this.scanActive = true;
    },
    getFunctions() {
      var that = this;
      if (that.assistantModel.functions) {
        axios.get("chat_prompt/ai_tools.json").then(response => {
          var myFunctions = that.assistantModel.functions.split(",");
          response.data.forEach(t => {
            if (t.type == "function") {
              if (myFunctions.includes(t.function.name)) {
                that.tools.push(t);
              }
            } else {
              that.tools.push(t);
            }
          });
        });
      }
    },
    cancelRequest() {
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel("Operation canceled by the user.");

        this.loading = false;
        this.stopAssistant();
      }
    },
    callSimulator() {
      var that = this;
      // this.loading = true;
      this.simulation = true;
      var data = {
        simulation: true,
        conversation: fun.clone(this.messages),
        message: this.simulatorMessage,
        instructions: this.assistantModel.simulator_instructions
      };
      setTimeout(function() {
        axios
          .post(that.serverURL + "/ask_assistant", data, {
            cancelToken: that.cancelTokenSource.token,
            withCredentials: true
          })
          .then(response => {
            this.loading = false;
            console.log(response);
            that.newMessage = response.data;
            console.log(that.newMessage);
            that.simulatorMessage = fun.clone(that.newMessage);
            // if (that.assistantModel.autoSimulate) {
            that.askAssistant();
            // }

            // that.loading = false;
          })

          .catch(error => {
            this.loading = false;
            this.streaming - false;
            if (axios.isCancel(error)) {
              console.log("Request canceled by the user:", error.message);
            } else {
              console.error("Request failed:", error);
            }
          });
      }, 10);
    },
    callOpenAI(gen, isAdmin, savedConversation) {
      // this.initEventSource();
      var that = this;
      this.simulation = false;
      this.streaming = "";
      var conversation;
      this.cancelTokenSource = axios.CancelToken.source();
      conversation = this.assistantModel.return_json ? [] : fun.clone(this.messages);
      if (savedConversation) {
        try {
          savedConversation = JSON.parse(savedConversation);
          if (savedConversation && savedConversation.length) {
            conversation = savedConversation;
            this.newMessage = "I want to continue";
            this.messages = savedConversation;
          }
        } catch (error) {
          // conversation = this.assistantModel.return_json ? [] : fun.clone(this.messages);
        }
      }

      // var conversation = savedConversation || this.assistantModel.return_json ? [] : fun.clone(this.messages);

      if (that.order_id) {
        localStorage.setItem(that.order_id, JSON.stringify(conversation));
      }
      if (that.conversation_id) {
        localStorage.setItem(that.conversation_id, JSON.stringify(conversation));
      }

      if (!gen && this.generatedMessage) {
        conversation.unshift({ content: this.generatedMessage, role: "user" });
      }
      this.tools = this.tools.filter(tool => {
        return !this.assistantModel.disabled_functions?.includes(tool);
      });
      var data = {
        db_portal: "emover_" + this.portal_id,
        conversation: conversation,
        message: this.newMessage,
        user_id: this.user_id,
        assistant_id: this.assistantId,
        company_id: this.companyId,
        thread_id: this.thread_id,
        delay: 0, // this.assistantModel.delay,
        instructions: this.instructions + " Today is " + fun.getFullDate(new Date()),
        tools: this.tools,
        no_streaming: this.noStreaming,
        model: "gpt-5.1",
        use_private_key: this.assistantModel.use_private_key,
        return_json: this.assistantModel.return_json,
        images: this.images, //"https://portal85.moverai.com/user_images/room.jpg",
        sid: null,
        extra: this.extra || {}
      };
      if (this.assistantModel.tool_choice == "selected_function" && this.tools && this.tools.length == 1) {
        //
        data.tool_choice = {
          type: "function",
          function: {
            name: this.tools[0]
          }
        };
      }
      var userMessage = {
        // conversation: this.messages,
        content: this.newMessage,
        thread_id: this.thread_id,

        role: isAdmin ? "system" : "user"
      };
      if (!that.messages.length) {
        // this.recordId=fun.guid()
      }
      if (!that.messages.length && that.hasInitialMessage) {
        //
      } else {
        that.messages.push(userMessage);
        that.saveMessages(userMessage);
      }

      that.newMessage = "";

      if (this.systemMessage.content) {
        that.messages.push(this.systemMessage);
      }
      that.scrollToBottom();

      // this.initSocket();
      setTimeout(function() {
        that
          .waitForSocketConnection()
          .then(sid => {
            data.sid = sid;
            return axios.post(that.serverURL + "/ask_assistant", data, {
              cancelToken: that.cancelTokenSource.token,
              withCredentials: true
            });
          })
          .then(response => {
            // that.loading = false;
            if (response.data.json) {
              that.$root.$emit("responseFromAssistant", response.data.json);
            }
            if (data.conversation.length == 2 && that.order_id) {
              that.updateStatus("sms_started");
            }
          })
          // that.loading = false;
          // that.chatReady = true;

          // // that.thread_id = d.thread_id;
          // // that.systemMessage.thread_id = that.thread_id;
          // var systemMessage = {
          //   content: that.streaming,
          //   thread_id: that.thread_id,
          //   role: "assistant",
          // };

          // if (systemMessage.content) {
          //   that.messages.push(systemMessage);

          //   that.focusOnText();
          //   that.scrollToBottom();
          // }
          // })
          .catch(error => {
            that.loading = false;
            that.errorMessage = (error && error.message) || "Assistant request failed";
            if (axios.isCancel(error)) {
              console.log("Request canceled by the user:", error.message);
            } else {
              console.error("Request failed:", error);
            }
          });
      }, 10);
    },
    startVoice() {
      if (!this.vc) this.vc = new VoiceClient();
      this.vc.start();
    },

    stopVoice() {
      if (this.vc) this.vc.stop();
    },
    startVoiceChat() {
      if (!this.voice) {
        this.voice = new VoiceClient();
        this.voice.start();
      }
      this.voiceActive = true;
    },

    stopVoiceChat() {
      if (this.voice) {
        this.voice.stop();
        this.voice = null;
      }
      this.voiceActive = false;
    },
    updateStatus(status) {
      var data = {
        _id: this.order_id,
        portal_id: this.portal_id,
        status: status
      };

      axios
        .post(this.serverURL + "/update_status", data, {
          withCredentials: true
        })
        .then(response => {
          // that.loading = false;
          console.log(response.data);
        });
    },
    checkIfFunction(resp, msg, systemMessage) {
      var that = this;
      if (resp.finish_reason == "function_call") {
        var func = that.functions.filter(f => {
          return f.name == msg.function_call.name;
        })[0];
        that.excludedData = func.excludedData;
        // systemMessage.text += "<br> Please wait while I'm " + func.prompt;
        that.loadingText = func.prompt;
        if (systemMessage.text) {
          that.messages.push(systemMessage);
        }

        that.loading = true;
        // setTimeout(function() {
        that.callFunction(msg.function_call.name, msg.function_call.arguments);
        // }, 1000);
      }
    },
    resend() {
      this.loading = false;
      this.callOpenAI();
    },
    removeItem(i) {
      this.images.splice(i, 1);
      this.frameList.splice(i, 1);
    },
    speechToText() {
      var that = this;
      var recognition = new (window.SpeechRecognition ||
        window.webkitSpeechRecognition ||
        window.mozSpeechRecognition ||
        window.msSpeechRecognition)();

      recognition.lang = "en-US"; // Set the language
      recognition.interimResults = false; // We want final results, not interim results
      recognition.maxAlternatives = 1; // We're only interested in the top result

      recognition.start(); // Start listening

      recognition.onresult = function(event) {
        console.log("You said: ", event.results[0][0].transcript);
        that.newMessage = event.results[0][0].transcript;
        that.callOpenAI();
      };

      recognition.onerror = function(event) {
        console.error("Error occurred in recognition: " + event.error);
      };
    },
    resetInstructions() {
      this.instructionModel.message_sections.forEach(s => {
        s.disabled = false;
      });
      this.assistantModel.disabled_functions = [];
      this.saveInstructions();
    },

    saveInstructions() {
      this.dialog = 0;
      var that = this;
      this.assistantModel.message_sections = this.instructionModel.message_sections;
      // this.assistantModel.disabled_functions = this.disabled_functions;
      var data = {
        metadata: {
          object_name: "chat_settings",
          db_name: "admin"
        },
        model: this.assistantModel
      };
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(function(response) {
          localStorage.removeItem(that.order_id);
          that.getAssistants();
        });

      //update instructions on server
      if (this.updateServer) {
        axios
          .post(fun.getServerURL("aichat") + "/add_data", data, {
            withCredentials: true
          })
          .then(function(response) {
            that.successMessage = "Instructions updated on productions";
          });
      }
    },
    saveMessages(message) {
      var data = {
        metadata: {
          object_name: "ai_chat",
          db_name: "admin"
        },
        model: {
          message: message,
          user_id: this.user_id,
          ai_chat_id: this.assistantId,
          order_id: this.order_id,
          session: this.session.toString()
        }
      };
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(function(response) {
          console.log(response.data);
        });
    },
    callFunction(functionName, args) {
      this.currentFunction = functionName;
      this[functionName](args);
    },
    responseFromFunction(resp) {
      this.loading = false;
      if (this.excludedData) {
        this.excludedData.forEach(e => {
          delete resp[e];
        });
      }

      var msg = {
        role: "function",
        name: this.currentFunction,
        content: JSON.stringify(resp)
      };
      this.timeResponded = new Date();
      this.callOpenAI(msg);
    },

    async calculateRoute(model) {
      var route = await axios
        .post(this.serverURL + "/get_route", model, {
          withCredentials: true
        })

        .catch(reason => {
          console.log(reason);
        });
      if (route.data) {
        model.route = route.data[0];
        var distance = 0;
        var travelTime = 0;
        model.route.leg.forEach(l => {
          distance += l.length;
          travelTime += l.travelTime;
        });
        model.distance = distance;
        model.mileage = (distance / 1.6 / 1000).toFixed(2);
        model.driving_time = (travelTime / 3600).toFixed(2);
      }

      return model;
    },
    tryBindDropTarget() {
      this.$nextTick(() => {
        if (this.$refs.userText && !this.dropTarget) {
          this.dropTarget = this.$refs.userText.$el;
        }
      });
    }
  },
  watch: {
    chatReady: "tryBindDropTarget",
    loading: "tryBindDropTarget",
    assistantId: "tryBindDropTarget",

    "$route.params.id": {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.initiateChat();
        }
      }
    }
  },
  computed: {
    messageListHeight() {
      // if (this.listHeight) {
      //   return this.listHeight + 50;
      // }
      return this.chatReady && this.assistantModel ? window.innerHeight - 350 : window.innerHeight - 350;
    }
  }
};
</script>
<style>
.assistant-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  color: #ccc;
  font-size: 14px;
  font-weight: 500;
}
.main-cont {
  max-height: 100dvh;
  overflow-y: auto;
  background-color: #fff;
}
.check-instructions {
  height: 200px;
  overflow: auto;
}
.assistant-list {
  max-height: 100px;
  overflow-y: auto;
  overflow-x: hidden;
}
.thread-list {
  max-height: 20vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.bg-dark {
  /* background-color: #b5d9cb; */
}

.ai-background {
  /* background: white; */
  height: 91vh;
  display: flex;
  flex-direction: column;
}

.chat-container {
  max-width: 300px;
}

.message {
  border-bottom: solid 1px;
  width: 100%;
}

.streaming p,
.message l {
  line-height: 30px;
}
/* .choices {
  max-height: 900px;
  overflow: auto;
} */
.message p,
.message li {
  line-height: 30px;
}

.message h3,
.streaming h3 {
  line-height: 30px;
}
.hidden-file-input {
  position: absolute;
  left: -9999px;
}
.choice-button {
}
.scan-stop-bar {
  position: fixed;
  bottom: 20px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 999;
}

.scan-stop-bar .v-btn {
  max-width: 420px;
  width: calc(100% - 40px);
}
.chat-bubble {
  background-color: #e6f8f1;
  padding: 16px 28px;
  -webkit-border-radius: 20px;
  -webkit-border-bottom-left-radius: 2px;
  -moz-border-radius: 20px;
  -moz-border-radius-bottomleft: 2px;
  border-radius: 20px;
  border-bottom-left-radius: 2px;
  display: inline-block;
}
.img-container {
  position: relative;
  display: inline-block;
}

.img-close-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  /* background: rgba(0, 0, 0, 0.6); */
  /* color: white; */
}

.typing {
  align-items: center;
  display: flex;
  height: 17px;
}
.scan-instruction {
  text-align: center;
  font-size: 14px;
  margin-bottom: 10px;
  color: #555;
}
.typing .dot {
  animation: mercuryTypingAnimation 1.8s infinite ease-in-out;
  background-color: #6cad96;
  border-radius: 50%;
  height: 7px;
  margin-right: 4px;
  vertical-align: middle;
  width: 7px;
  display: inline-block;
}

.typing .dot:nth-child(1) {
  animation-delay: 200ms;
}

.typing .dot:nth-child(2) {
  animation-delay: 300ms;
}

.typing .dot:nth-child(3) {
  animation-delay: 400ms;
}

.typing .dot:last-child {
  margin-right: 0;
}
.scan-warning {
  position: fixed;
  bottom: 90px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: rgba(255, 0, 0, 0.8);
  padding: 8px;
  z-index: 999;
}
.user-input-row {
  /* position: fixed;
  bottom: 0;

  background: white;
  z-index: 10; */
  width: 100%;
  flex-shrink: 0;
  /* background: white; */
  z-index: 10;
}
@keyframes mercuryTypingAnimation {
  0% {
    transform: translateY(0px);
    background-color: #6cad96;
  }

  28% {
    transform: translateY(-7px);
    background-color: #9ecab9;
  }

  44% {
    transform: translateY(0px);
    background-color: #b5d9cb;
  }
}

#message-list {
  /* height: calc(100vh - 350px); */
  /* height: 80vh; */
  /* border: solid dotted; */
  overflow-y: auto;
  overflow-x: hidden;
  width: calc(100% - 15px);
  flex: 1 1 auto;
}

.image-block {
  overflow-y: hidden;
  max-height: 140px;
}

.fixed {
  position: fixed;

  bottom: 0;
  height: 120px;
  /* width: 90%; */

  width: calc(100% - 25px);
}

.truncate-text-button {
  max-width: 200px;
  /* Adjust width as needed */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
